import { FETCH_CONVERSATION, FETCH_MESSAGE_LIST, FETCH_MORE_MESSAGE, CHANGE_RECIPIENT, UPDATE_CHAT, UPDATE_MEDIA_LAYOUT, UPDATE_TO_READ } from './types';

const initialState = {
  conversations: [],
  messages: [],
  shouldMediaRender: false,
  sharedPhotos: [],
  recipient: '',
};

export default (state = initialState, actions) => {
  switch (actions.type) {
    case FETCH_CONVERSATION:
      state.conversations = actions.payload.conversations;
      return { ...state };
    case FETCH_MESSAGE_LIST:
      state.messages = actions.payload.messages;
      state.sharedPhotos = actions.payload.sharedPhotos;
      return { ...state };
    case FETCH_MORE_MESSAGE:
      if (actions.payload.messages.length > 0) state.messages = [...actions.payload.messages, ...state.messages];
      if (actions.payload.sharedPhotos.length > 0) state.sharedPhotos = [...actions.payload.sharedPhotos, ...state.sharedPhotos];
      return { ...state };
    case CHANGE_RECIPIENT:
      state.recipient = actions.payload.recipient;
      state.shouldMediaRender = false;
      return { ...state };
    case UPDATE_CHAT:
      state.messages = [...state.messages, actions.payload.message];
      return { ...state };
    case UPDATE_MEDIA_LAYOUT:
      // state.shouldMediaRender = !state.shouldMediaRender;
      state.shouldMediaRender = false;
      return { ...state };
    case UPDATE_TO_READ:
      state.isUnread = 0;
      return { ...state };
    default:
      return { ...state };
  }
};
